/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import type { SimpleTokenModel} from '@delon/auth';
import type { AlainAuthConfig } from '@delon/util/config';

import { isAnonymous, throwErr } from '@delon/auth';
import { DelonTokenService } from '@eliboo/micro-ng/auth-delon';
import { useMicroNgConfig } from '@eliboo/micro-ng/core';
import { switchMap } from 'rxjs';

import { MICRO_API_CONTEXT, MICRO_APP_SIGNATURE_CONTEXT } from './context';

function newReq(req: HttpRequest<unknown>, model: SimpleTokenModel, options: AlainAuthConfig): HttpRequest<unknown> {
  const { token_send_template, token_send_key } = options;
  const token = token_send_template!.replace(/\$\{([\w]+)\}/g, (_: string, g) => model[g]);
  switch (options.token_send_place) {
    case 'body': {
      const body: any = req.body || {};
      body[token_send_key!] = token;
      req = req.clone({
        body,
      });
      break;
    }
    case 'header':
      // eslint-disable-next-line no-case-declarations
      const obj: any = {};
      obj[token_send_key!] = token;
      req = req.clone({
        setHeaders: obj,
      });
      break;
    case 'url':
      req = req.clone({
        params: req.params.append(token_send_key!, token),
      });
      break;
  }
  return req;
}

export const microAuthSimpleInterceptor: HttpInterceptorFn = (req, next) => {
  const context = req.context.get(MICRO_API_CONTEXT);
  const isMicroApi = !!context;
  if (!isMicroApi) return next(req);
  const { injector, appId } = context;
  const configs = useMicroNgConfig(injector);
  if (appId !== configs.appId) return next(req);

  const tokenService = injector.get(DelonTokenService);
  const options = tokenService.options;
  console.log('options', options);

  if (isAnonymous(req, options)) return next(req);
  const signatureContext = req.context.get(MICRO_APP_SIGNATURE_CONTEXT);
  if (signatureContext) {
    return signatureContext.getSignature().pipe(
      switchMap((signature) => {
        return next(req.clone({ setHeaders: { [signatureContext.headerKey ?? 'Signature']: signature } }));
      }),
    );
  } else {
    if (!tokenService) {
      return next(req);
    }
    const model = tokenService.get() as SimpleTokenModel;
    if (CheckSimple(model)) return next(newReq(req, model, options));

    return throwErr(req, options);
  }
};
function CheckSimple(model: null | SimpleTokenModel): boolean {
  return model != null && typeof model.token === 'string' && model.token.length > 0;
}
